/// <amd-module name="Reporting/Visuals/VisualMessages/CompactChartErrorWarningComponent" />
import * as React from "react";
import * as Resources from "Reporting/Visuals/Resources";
import { VssComponent } from "VSS/Platform/Layout";
import { Icon } from "VSSUI/Icon";

interface CompactChartErrorWarningComponentProps {
    role?: string;
}

/** For warnings /errors on the compact chart for which we render a small icon without any text but provide a tooltip
 * For now keeping the tooltip message generic . Can be extended with props to be customizable for different errors / warnings
 */
export class CompactChartErrorWarningComponent extends VssComponent<CompactChartErrorWarningComponentProps> {
    public render(): JSX.Element {
        return (
            <Icon
                ariaLabel={Resources.CompactChartErrorWarning}
                className="compact-chart-error-warning-icon"
                iconName="Error"
                tooltipProps={{ text: Resources.CompactChartErrorWarningTooltip }}
                role={this.props.role}
            />
        );
    }
}
